// test1656
(1656 && 0);
